import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FiShoppingCart, FiHeart, FiArrowRight } from "react-icons/fi";
import { LuHeartHandshake } from "react-icons/lu";
import "./PortalSelectionModal.css";

const PortalSelectionModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if user has already selected a portal (pharmacy or healthcare)
    const selected = localStorage.getItem("selectedPortal");
    const hasSelected = selected === "pharmacy" || selected === "healthcare";

    // Don't show modal on admin, seller, centre, user dashboard or auth/management routes
    const isDashboardOrAuth =
      location.pathname.startsWith("/admin") ||
      location.pathname.startsWith("/manage4ceps-admin") ||
      location.pathname.startsWith("/centre") ||
      location.pathname.startsWith("/center") ||
      location.pathname.startsWith("/dashboard-profile") ||
      location.pathname.startsWith("/user-dashboard") ||
      location.pathname.startsWith("/user-profile") ||
      location.pathname.startsWith("/seller") ||
      location.pathname.startsWith("/doctors") ||
      location.pathname.startsWith("/package") ||
      location.pathname.startsWith("/statement") ||
      location.pathname.startsWith("/earning") ||
      location.pathname.startsWith("/earningSummary") ||
      location.pathname.startsWith("/registered") ||
      location.pathname.startsWith("/all-services-list") ||
      location.pathname.startsWith("/userBooking") ||
      location.pathname.startsWith("/category-services") ||
      location.pathname.startsWith("/appointments") ||
      location.pathname.startsWith("/requests") ||
      location.pathname.startsWith("/orders") ||
      location.pathname.startsWith("/medical-history") ||
      location.pathname.startsWith("/booking-report") ||
      location.pathname.startsWith("/add-insurance") ||
      location.pathname.startsWith("/user-helpAndSupport") ||
      location.pathname.startsWith("/centre-helpAndSupport") ||
      location.pathname.startsWith("/users");

    if (!hasSelected && !isDashboardOrAuth) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [location.pathname]);

  // Lock background scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      const originalStyle = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";

      return () => {
        document.body.style.overflow = originalStyle || "";
        document.documentElement.style.overflow = "";
      };
    }
  }, [isOpen]);

  const handleSelectOption = (section) => {
    localStorage.setItem("selectedPortal", section);
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
    setIsOpen(false);

    if (section === "pharmacy") {
      navigate("/shop");
    } else if (section === "healthcare") {
      navigate("/");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="portal-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="portal-modal-title">
      <div className="portal-modal-container">
        {/* Header with Logo on Left, Title/Subtitle Centered */}
        <div className="portal-modal-header">
          <div className="portal-modal-logo-wrap">
            <img
              src="/assets/images/logo/BHARATLOGO-011.webp"
              alt="4Ceps Logo"
              className="portal-modal-logo"
            />
          </div>
          <div className="portal-modal-header-text">
            <h2 id="portal-modal-title" className="portal-modal-title">
              Welcome to <span>4Ceps</span>
            </h2>
            <p className="portal-modal-subtitle">
              Please choose an option to proceed:
            </p>
          </div>
        </div>

        {/* Options Grid */}
        <div className="portal-cards-grid">
          {/* Option 1: Online Pharmacy */}
          <div className="portal-option-column">
            <div
              className="portal-image-card pharmacy-image-card"
              role="button"
              tabIndex={0}
              onClick={() => handleSelectOption("pharmacy")}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleSelectOption("pharmacy");
                }
              }}
            >
              <img
                src="/assets/images/pharmacy_stock.jpg"
                alt="Online Pharmacy"
                className="portal-card-img"
              />
            </div>

            <button
              type="button"
              className="portal-card-btn pharmacy-btn"
              onClick={() => handleSelectOption("pharmacy")}
            >
              <FiShoppingCart size={15} />
              <span>Online Pharmacy</span>
              <FiArrowRight size={15} />
            </button>
          </div>

          {/* Option 2: Healthcare Services */}
          <div className="portal-option-column">
            <div
              className="portal-image-card healthcare-image-card"
              role="button"
              tabIndex={0}
              onClick={() => handleSelectOption("healthcare")}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleSelectOption("healthcare");
                }
              }}
            >
              <img
                src="/assets/images/healthcare_stock.jpg"
                alt="Healthcare Services"
                className="portal-card-img"
              />
            </div>

            <button
              type="button"
              className="portal-card-btn healthcare-btn"
              onClick={() => handleSelectOption("healthcare")}
            >
              <LuHeartHandshake size={15} />
              <span>Healthcare Services</span>
              <FiArrowRight size={15} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortalSelectionModal;
